export class UserModel {
}
export class StudentRealEstateModel {
}
export class LogoPlacements {
}
